import {observer} from 'mobx-react';
import React from 'react';
import {ClassroomVideoStore} from './ClassroomVideoStore';

@observer
export class RemoteVideoControls extends React.Component<{ store: ClassroomVideoStore }> {
  render() {
    return null;
  }
}
